import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=a12c7c1a"
import script from "./entity.js?vue&type=script&lang=js&external"
export * from "./entity.js?vue&type=script&lang=js&external"
import style0 from "./entity.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports